'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartItemState() {
}
export { $c_Lmealorama_StoreCartItemState as $c_Lmealorama_StoreCartItemState };
$p = $c_Lmealorama_StoreCartItemState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartItemState;
/** @constructor */
function $h_Lmealorama_StoreCartItemState() {
}
export { $h_Lmealorama_StoreCartItemState as $h_Lmealorama_StoreCartItemState };
$h_Lmealorama_StoreCartItemState.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lmealorama_StoreCartItemState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.StoreCartItemState", ({
  k1: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_StoreCartItemState as $d_Lmealorama_StoreCartItemState };
//# sourceMappingURL=mealorama.-Store-Cart-Item-State.js.map
